import { render, staticRenderFns } from "./anularAfiliacion.vue?vue&type=template&id=71250956&"
import script from "./anularAfiliacion.vue?vue&type=script&lang=js&"
export * from "./anularAfiliacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports